import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { type ReactElement } from "react";
import { AuthProvider, useAuth } from "./auth/AuthContext";
import Layout from "./pages/Layout";
import LoginPage from "./pages/LoginPage";
import Screener from "./pages/Screener";
import BondPage from "./pages/BondPage";
import Portfolio from "./pages/Portfolio";
import Dashboard from "./pages/Dashboard";
import CalendarPage from "./pages/CalendarPage";
import StatsPage from "./pages/StatsPage";
import AlertsPage from "./pages/AlertsPage";

function RequireAuth({ children }: { children: ReactElement }) {
  const { status } = useAuth();
  const location = useLocation();
  if (status === "loading") {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "var(--ink-soft)",
          fontSize: 13,
        }}
      >
        проверяем сессию…
      </div>
    );
  }
  if (status === "anonymous") {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <RequireAuth>
                <Layout />
              </RequireAuth>
            }
          >
            <Route index element={<Screener />} />
            <Route path="bond/:secid" element={<BondPage />} />
            <Route path="portfolio" element={<Portfolio />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="calendar" element={<CalendarPage />} />
            <Route path="stats" element={<StatsPage />} />
            <Route path="alerts" element={<AlertsPage />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
